<script>
  import Graph from "../../shared/Graph.svelte";
  import data1 from "../../stores/Graph_L2.js";
  import { _ } from "svelte-i18n";
</script>

<div class="title">
  <h2>{$_("lesson-Z30Ce.h2-0")}</h2>
</div>
<hr />
<div class="text">
  <p>
    {@html $_("lesson-Z30Ce.p-0")}
  </p>
  <p>
    {$_("lesson-Z30Ce.p-1")}
  </p>
  <Graph graph={data1} width="500" height="350" style="display: block; margin: 0 auto;"/>
  <p style="text-align: center">
    <i>{$_("lesson-Z30Ce.i-0")}</i>
  </p>
  <p>
    {@html $_("lesson-Z30Ce.p-2")}
  </p>
  <p>
    {$_("lesson-Z30Ce.p-3")}
    {`$$G=\\left(V,E,d\\right)$$`}
  </p>
  <p style="text-align: center">{$_("lesson-Z30Ce.p-4")}</p>
  <p>
    {`$$V=\\left\\{v_1,v_2,...\\right\\}$$`}
    {`$$E\\subseteq\\left\\{\\left\\{v_i,v_j\\right\\}|\\left(v_i,v_j\\right)\\in V^2\\wedge v_i\\neq v_j\\right\\}$$`}
    {`$$d:E\\to\\mathbb{R}$$`}
  </p>
  <p>
    {$_("lesson-Z30Ce.p-5")}
  </p>
  <ul>
    <li>{@html $_("lesson-Z30Ce.li-0")}</li>
    <li>{@html $_("lesson-Z30Ce.li-1")}</li>
    <li>{@html $_("lesson-Z30Ce.li-2")}</li>
    <li>{@html $_("lesson-Z30Ce.li-3")}</li>
  </ul>
  <p>
    {$_("lesson-Z30Ce.p-6")}
    {`$$V=\\left\\{A,B,C,D\\right\\}$$`}
    {`$$E=\\left\\{\\left\\{A,B\\right\\},\\left\\{A,C\\right\\},\\left\\{A,D\\right\\},\\left\\{B,C\\right\\},\\left\\{B,D\\right\\},\\left\\{C,D\\right\\}\\right\\}$$`}
    {`$$d:E\\to\\begin{cases}2.5 & \\text{if }E=\\left\\{A,B\\right\\} \\\\ 3.3 & \\text{if }E=\\left\\{A,C\\right\\} \\\\ 5.7 & \\text{if }E=\\left\\{A,D\\right\\} \\\\ 4.1 & \\text{if }E=\\left\\{B,C\\right\\} \\\\ 3.4 & \\text{if }E=\\left\\{B,D\\right\\} \\\\ 5.6 & \\text{if }E=\\left\\{C,D\\right\\}\\end{cases}$$`}
  </p>
  <p>
    {@html $_("lesson-Z30Ce.p-7")}
  </p>
</div>

<style>
  .title h2 {
    background: -webkit-linear-gradient(90deg, #1a91bc, #2eb6e8);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  hr {
    border: 1px solid white;
    border-top: 1px solid #ddd;
    margin: 20px auto;
  }
</style>
